import React, { useState, useContext, useRef } from 'react';
import { useDispatch } from '../../store/index.js';
import { useSelector } from '../../store/index.js';
import { CloseIcon } from '../../icons/index.js';
import { ChangePage } from '../../store/reducers/menu.js';

function BettingDetailModal() {
    const dispatch = useDispatch();
    const {wingoBettingDetail} = useSelector((state) => (state.auth));

    const greenColor = ['Green', '1', '3', '7','9'];
    const redColor = ['Red', '2', '4', '6','8'];
    const violetColor = ['Violet'];
    const violetRedColor = ['0'];
    const violetGreenColor = ['5'];

    const backColor = (item) => {
        if(greenColor.includes(item)) {
            return "bg-green-400";
        } else if(redColor.includes(item)) {
            return "bg-coral-500";
        } else if(violetColor.includes(item)) {
            return "bg-purple-800";
        } else if(violetRedColor.includes(item)) {
            return "purple-coral";
        } else if(violetGreenColor.includes(item)) {
            return "purple-green";
        }
    }

    return (
        <div className="modal-overlay fixed inset-0 flex items-center justify-start text-white">
            <div className="fixed inset-0 flex items-center justify-start px-4">
                <div style={{maxWidth: "560px", maxHeight: '666px', margin: '0 auto', backgroundColor: "rgba(22, 28, 42, 0.95)"}} className="w-full p-4 sm:p-6 md:p-8 bg-opacity-40 rounded-5 shadow-bottom_1 flex justify-start flex-col items-center">                    
                    <div className="text-white font-plus font-bold text-18 leading-22 flex flex-row w-full justify-end items-end" onClick={() => dispatch(ChangePage(""))}><CloseIcon/></div>  
                    <span className='text-24 text-white'>Detail Info</span>
                    <div className='flex flex-col gap-3 w-full justify-start pt-2'>
                        <div className="flex flex-col w-full justify-start items-start w-full">
                            <div className='flex justify-start items-center'>
                                <span className='text-18 text-white'>Period: &nbsp;</span>
                                <span className='text-20 text-white text-medium'>{wingoBettingDetail.gamePeriod}</span>
                            </div>
                        </div>
                        <div className="flex flex-col w-full justify-start items-start w-full">
                            <div className='flex justify-start items-center'>
                                <span className='text-18 text-white'>BetType: &nbsp;</span>
                                <span className='text-20 text-white'>{wingoBettingDetail.betType}</span>
                            </div>
                        </div>
                        <div className="flex flex-col w-full justify-start items-start w-full">
                            <div className='flex justify-start items-center'>
                                <span className='text-18 text-white'>Amount: &nbsp;</span>
                                <span className='text-20 text-white'>{wingoBettingDetail.amount}</span>
                            </div>
                        </div>
                        <div className="flex flex-col w-full justify-start items-start w-full">
                            <div className='flex justify-start items-center'>
                                <span className='text-18 text-white'>Delivery: &nbsp;</span>
                                <span className='text-20 text-white'>{wingoBettingDetail.amount * 0.98}</span>
                            </div>
                        </div>
                        <div className="flex flex-col w-full justify-start items-start w-full">
                            <div className='flex justify-start items-center'>
                                <span className='text-18 text-white'>Fee: &nbsp;</span>
                                <span className='text-20 text-white'>{wingoBettingDetail.amount * 0.02}</span>
                            </div>
                        </div>
                        <div className="flex flex-col w-full justify-start items-start w-full">
                            <div className='flex justify-start items-center'>
                                <span className='text-18 text-white'>Status: &nbsp;</span>
                                <span className='text-20 text-white'>{wingoBettingDetail.status}</span>
                            </div>
                        </div>
                        <div className="flex flex-col w-full justify-start items-start w-full">
                            <div className='flex justify-start items-center'>
                                <span className='text-18 text-white'>Select: &nbsp;</span>
                                <div className='flex flex-row justify-center items-center gap-1'>
                                    <div className={`rounded-[40px] ${backColor(wingoBettingDetail.betValue)} w-8 h-8 relative`}>
                                        <span className={`h-4 w-4 text-19 right-1 top-1 absolute`}>{!isNaN(wingoBettingDetail.betValue) ? wingoBettingDetail.betValue : ""}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BettingDetailModal;